import { TOOL_CATEGORIES } from '../../modules/tools';
import EpochConverterTool from './EpochConverterTool';
import TaxCalculatorTool from './TaxCalculatorTool';
import TextFormatterTool from './TextFormatterTool';

const CATEGORY_LABELS = new Map(TOOL_CATEGORIES.map((category) => [category.id, category.label]));

const ToolWorkspace = ({ tool }) => {
  if (!tool) {
    return (
      <div className="rounded-lg border border-dashed border-slate-300 bg-white px-6 py-10 text-center text-slate-400 dark:border-slate-700 dark:bg-slate-900">
        Selecione uma ferramenta para começar.
      </div>
    );
  }

  return (
    <div className="space-y-6 rounded-2xl border border-slate-200 bg-white px-6 py-6 shadow-lg shadow-slate-200/40 dark:border-slate-800 dark:bg-slate-900/80 dark:shadow-none">
      <div>
        <span className="text-xs font-semibold uppercase tracking-wide text-brand-primary">
          {CATEGORY_LABELS.get(tool.category) ?? tool.category}
        </span>
        <h1 className="mt-1 text-2xl font-bold text-slate-800 dark:text-slate-100">
          {tool.name}
        </h1>
      </div>

      <div>
        {tool.type === 'text-formatter' && <TextFormatterTool tool={tool} />}
        {tool.type === 'epoch-converter' && <EpochConverterTool />}
        {tool.type === 'tax-calculator' && <TaxCalculatorTool />}
      </div>
    </div>
  );
};

export default ToolWorkspace;
